import { OktaAuth } from '@okta/okta-auth-js';

export const oktaAuth = new OktaAuth({
  issuer: import.meta.env.VITE_APP_OKTA_ISSUER,
  clientId: import.meta.env.VITE_APP_OKTA_CLIENT_ID,
  redirectUri: import.meta.env.VITE_APP_OKTA_REDIRECT_URI,
  scopes: ['openid', 'profile', 'email', 'groups'],
  pkce: true,
});
